import * as z from 'zod/v4';

export const SYSTEM_VARIANTS = ['SROW', 'MSYS', 'RSYS', 'USYS', 'REDUCERA_FRITT'] as const;

export const systemTypeEnum = z.enum(SYSTEM_VARIANTS);
export type SystemType = z.infer<typeof systemTypeEnum>;
